const transferRequest = {
    list: () => 'store/staff/requested/procurements',
    submit:()=> 'store/internal-movement',
    storeList:()=>'store/internal-movement/stores',
    getAvailableBarcodes:()=>'store/movement/available-barcodes',
    markAsDelivered: () => "store/movement/deliver",
}

export default transferRequest